import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b76deca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "_page_wrap"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "leadership_title"
}
const _hoisted_5 = { class: "_block_title1 about_title" }
const _hoisted_6 = { class: "default_text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "block_action"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 2,
  class: "block_action"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "_block_title1 about_title" }
const _hoisted_13 = {
  key: 0,
  class: "default_text"
}
const _hoisted_14 = {
  key: 1,
  class: "default_text"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["id"]
const _hoisted_17 = { class: "default_text _block_content2" }
const _hoisted_18 = {
  key: 0,
  class: "leadership_title"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "_page_wrap"
}
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "_text_join" }
const _hoisted_24 = { class: "job_block" }
const _hoisted_25 = { class: "_block_title_join" }
const _hoisted_26 = { class: "default_text" }
const _hoisted_27 = { class: "_block_title1 about_title" }
const _hoisted_28 = {
  key: 0,
  class: "default_text"
}
const _hoisted_29 = {
  key: 1,
  class: "default_text"
}
const _hoisted_30 = ["id"]
const _hoisted_31 = { class: "default_text _block_content2" }
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 对不起，本浏览器不支持视频播放 ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "join_action_wrap" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "join_action",
    href: "mailto:nihao@huamei2001.com"
  }, " 请发送简历至 leewei@huamei2001.com ")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tezhongbing",
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/hm2022/artworks/%E7%89%B9%E7%A7%8D%E5%85%B51.png?versionId=CAEQLhiBgMCytvXu9BciIGQwNjEwY2FkMjNjMTRiY2NhYTc2MTQzMDM3MGE4Yjhj",
  alt: ""
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scroll_enter = _resolveComponent("scroll-enter")!
  const _component_TImageDecorBrush = _resolveComponent("TImageDecorBrush")!
  const _component_TImageDecorVideo = _resolveComponent("TImageDecorVideo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currTab != '加入\n华美')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData[_ctx.currTab], (block, blockIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass({
                _page_block:true,
                _reverse: block.reverse,
                _leadership_block:_ctx.currTab=='华美\n寄语'
            }),
              key: block.title,
              id: _ctx.idHash(block.title)
            }, [
              (!(block.level && block.level==2))
                ? (_openBlock(), _createBlock(_component_scroll_enter, {
                    key: 0,
                    _inactive: blockIndex<1,
                    _duration: 0.3,
                    _direction: block.reverse ? 'right':'left',
                    class: _normalizeClass({_half_piece:true, portrait:block.portrait, _left:!block.reverse, _right:block.reverse})
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass({_text_left:!block.reverse, _text_right:block.reverse})
                      }, [
                        (block.title)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              (block.title=='华美顾问集团执行董事 王炜文')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "领导者"))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_5, _toDisplayString(block.title), 1),
                              _createElementVNode("div", _hoisted_6, _toDisplayString(block.summary), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.content, (l) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: l,
                                  class: "default_text _block_content_line"
                                }, [
                                  (!l.name)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(l), 1))
                                    : _createCommentVNode("", true),
                                  (l.name)
                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(l.name), { key: 1 }))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (block.action)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("a", {
                                      href: `mailto:${block.action.email}`
                                    }, _toDisplayString(block.action.text) + _toDisplayString(block.action.email), 9, _hoisted_9)
                                  ]))
                                : _createCommentVNode("", true),
                              (block.links && block.links.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.links, (link) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        href: link.url,
                                        target: "_blank",
                                        class: "blue_link",
                                        key: link.url
                                      }, _toDisplayString(link.text), 9, _hoisted_11))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.children, (b1, b1i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: b1.title
                          }, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(b1.title), 1),
                            (b1.summary)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(b1.summary), 1))
                              : _createCommentVNode("", true),
                            (b1.remark)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(b1.remark), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b1.content, (l1) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: l1,
                                class: "_block_content_line default_text"
                              }, _toDisplayString(l1), 1))
                            }), 128)),
                            (b1i != block.children.length-1)
                              ? (_openBlock(), _createElementBlock("br", _hoisted_15))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b1.children, (b2) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: b2.title
                              }, [
                                _createElementVNode("div", {
                                  class: "_block_title2",
                                  id: b2.title
                                }, _toDisplayString(b2.title), 9, _hoisted_16),
                                _createElementVNode("div", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b2.content, (l2) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "_block_content_line",
                                      key: l2
                                    }, _toDisplayString(l2), 1))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["_inactive", "_duration", "_direction", "class"]))
                : _createCommentVNode("", true),
              (block.portrait)
                ? (_openBlock(), _createBlock(_component_scroll_enter, {
                    key: 1,
                    _inactive: blockIndex<1,
                    class: "portrait_img_wrap _half_piece"
                  }, {
                    default: _withCtx(() => [
                      (block.title=='华美顾问集团执行董事 王炜文')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                        : _createCommentVNode("", true),
                      _createVNode(_component_TImageDecorBrush, {
                        decorColor: blockIndex,
                        class: "portraint_img _half_piece",
                        img: block.images,
                        alt: ""
                      }, null, 8, ["decorColor", "img"])
                    ]),
                    _: 2
                  }, 1032, ["_inactive"]))
                : _createCommentVNode("", true),
              (!block.portrait)
                ? (_openBlock(), _createBlock(_component_scroll_enter, {
                    key: 2,
                    _inactive: blockIndex<1,
                    class: "_half_piece_join"
                  }, {
                    default: _withCtx(() => [
                      (!block.video)
                        ? (_openBlock(), _createBlock(_component_TImageDecorBrush, {
                            key: 0,
                            decorColor: blockIndex,
                            _direction: block.reverse ? 'right':'left',
                            img: block.images,
                            alt: "",
                            imageStyle: block.imageStyle
                          }, null, 8, ["decorColor", "_direction", "img", "imageStyle"]))
                        : _createCommentVNode("", true),
                      (block.video)
                        ? (_openBlock(), _createBlock(_component_TImageDecorVideo, {
                            key: 1,
                            decorColor: 2,
                            img: block.video,
                            autoplay: block.autoplay,
                            loop: block.loop,
                            controls: block.controls,
                            muted: block.muted
                          }, null, 8, ["img", "autoplay", "loop", "controls", "muted"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["_inactive"]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.currTab == '加入\n华美')
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageData[_ctx.currTab], (block, blockIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "_page_block_join",
              key: block.title,
              id: _ctx.idHash(block.title)
            }, [
              (!(block.level && block.level==2))
                ? (_openBlock(), _createBlock(_component_scroll_enter, {
                    key: 0,
                    _inactive: blockIndex<1,
                    _duration: 0.3,
                    _direction: block.reverse ? 'right':'left',
                    class: _normalizeClass({_half_piece_join:true, _left:!block.reverse, _right:block.reverse})
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(block.title), 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(block.summary), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.children, (b1) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: b1.title,
                            class: "job_block"
                          }, [
                            _createElementVNode("div", _hoisted_27, _toDisplayString(b1.title), 1),
                            (b1.summary)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(b1.summary), 1))
                              : _createCommentVNode("", true),
                            (b1.remark)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(b1.remark), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b1.content, (l1) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: l1,
                                class: "_block_content_line default_text"
                              }, _toDisplayString(l1), 1))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b1.children, (b2) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: b2.title
                              }, [
                                _createElementVNode("div", {
                                  class: "_block_title2",
                                  id: b2.title
                                }, _toDisplayString(b2.title), 9, _hoisted_30),
                                _createElementVNode("div", _hoisted_31, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(b2.content, (l2) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "_block_content_line",
                                      key: l2
                                    }, _toDisplayString(l2), 1))
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["_inactive", "_duration", "_direction", "class"]))
                : _createCommentVNode("", true),
              _createVNode(_component_scroll_enter, {
                _inactive: blockIndex<1,
                class: _normalizeClass({_half_piece_join:true})
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.videos, (video) => {
                    return (_openBlock(), _createBlock(_component_TImageDecorVideo, {
                      controls: "",
                      key: video,
                      alt: "",
                      img: video
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("source", {
                          src: video,
                          type: "video/mp4"
                        }, null, 8, _hoisted_32),
                        _hoisted_33
                      ]),
                      _: 2
                    }, 1032, ["img"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["_inactive"])
            ], 8, _hoisted_22))
          }), 128)),
          _hoisted_34,
          _hoisted_35
        ]))
      : _createCommentVNode("", true)
  ], 64))
}